// extracted by mini-css-extract-plugin
export default {"root":"RescheduleClassesTypeChip_root__DfNcr"};